
import React, { useMemo } from 'react';
import {
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import {SectionKeys, Tabs, QUESTION_TYPE } from '../../../_constants/individualFields.constant';
import { DYNAMIC_QUESTION_ELEMENT } from '../../../components/DynamicQuestion/constants';
import CustomTextareaField from '../../../components/DynamicQuestion/QuestionElement/CustomTextareaField';
import { useSelector } from 'react-redux';

const CommercialDescription = () => {
  const {allFields}= useSelector(state => state.individualField.initialFieldsList)
  const commercialFields = useMemo(
    () =>
      allFields.filter(
        (field) =>
          field.fieldDisplayPosition === `${Tabs.CHOSEN_OPTIONS}.${SectionKeys.COMMERCIAL_DESCRIPTION}`
      ),
    [allFields]
  );

  return (
    <>
      {commercialFields.map((question) => {
        const {label, questionType } = question;
        const Element = DYNAMIC_QUESTION_ELEMENT[questionType] || CustomTextareaField;

        return (
          <React.Fragment key={`${question.fieldDisplayPosition}.${question.keyName}`}>
            {questionType !== QUESTION_TYPE.CHECKBOX ? (
              <>
                <Grid container spacing={1} sx={{ px: 2,mb: 2}}>
                  <Grid size={{ xs: 12}}>
                    <Typography variant="body1">{label}</Typography>
                  </Grid>
                  <Grid size={{ xs: 12}}>
                    <Divider sx={{ my: 0 }} />
                  </Grid>
                </Grid>
                <Grid container sx={{ px: 2 }}>
                  <Grid size={{ xs: 12}}>
                    <Element question={question} />
                  </Grid>
                </Grid>
              </>
            ) : (
              <Grid container sx={{ px: 2 }}>
                <Grid size={{ xs: 12}}>
                  <Element question={question} />
                </Grid>
              </Grid>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CommercialDescription;
